import React, { Fragment } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import {
  Container,
  Navbar,
  Nav,
  Dropdown,
  Image,
  Badge,
} from "react-bootstrap";
import { ShoppingCart, User, Settings, Package, LogOut } from "react-feather"; // Import cart icon
import { useAuth } from "../contexts/authContext";
import { useCart } from "../contexts/cartContext"; // Import CartContext
import { cartSession } from "../utils/cart";

import logo from "../logo.png";
import sheenlacLogo from "../resources/img/sheenlac.png";

const PublicLayout = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const { cartCount } = useCart(); // Use CartContext to get cart count
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    cartSession.clear();
    navigate("/");
  };

  return (
    <Fragment>
      <Navbar fixed="top" expand="lg" className="bg-white mb-auto header">
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <Image
              src={sheenlacLogo}
              alt="Sheenlac"
              fluid
              style={{ width: "clamp(100px, 15vw, 150px)" }}
              className="me-2 me-md-3"
            />
            <Image
              src={logo}
              alt={process.env.REACT_APP_PORTAL}
              fluid
              style={{ width: "clamp(150px, 20vw, 200px)" }}
              className=""
            />
          </Navbar.Brand>

          <Navbar.Collapse className="justify-content-center d-none d-lg-flex">
            <Nav>
              <Nav.Link as={Link} to="/" className="mx-2">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about-us" className="mx-2">
                About Us
              </Nav.Link>
              <Nav.Link as={Link} to="/contact-us" className="mx-2">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <div className="ms-auto d-flex align-items-center">
            <Dropdown align="end">
              <Dropdown.Toggle className="bg-transparent border-0">
                <div className="d-inline-block p-0 rounded-circle bg-primary user-profile">
                  <User size={18} />
                </div>
              </Dropdown.Toggle>
              {!isAuthenticated && (
                <Dropdown.Menu className="shadow border-0 fs-medium">
                  <div className="p-3">
                    <div className="fw-medium mb-2">Welcome</div>
                    <div className="fw-light">
                      To access account and manage orders
                    </div>
                  </div>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    as={Link}
                    to="/login"
                    className="py-2 text-light-emphasis"
                  >
                    LOGIN
                  </Dropdown.Item>

                  <Dropdown.Item
                    as={Link}
                    to="/register"
                    className="py-2 text-light-emphasis"
                  >
                    New Customer? <b>SIGNUP</b>
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
              {isAuthenticated && (
                <Dropdown.Menu className="shadow border-0 fs-medium">
                  <div className="p-2 text-center">
                    <div className="fw-medium text-dark-emphasis">
                      Hi {user?.firstName}
                    </div>
                    <Badge bg="secondary" className="text-uppercase">
                      {user?.role === "super_admin"
                        ? "Super Admin"
                        : user?.role === "administrator"
                        ? "Administrator"
                        : "Customer"}
                    </Badge>
                  </div>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    as={Link}
                    to="/orders"
                    className="py-2 text-light-emphasis"
                  >
                    <Package size={16} className="me-2" />
                    Orders
                  </Dropdown.Item>

                  <Dropdown.Item
                    as={Link}
                    to="/profile"
                    className="py-2 text-light-emphasis"
                  >
                    <Settings size={16} className="me-2" />
                    Account Details
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    onClick={handleLogout}
                    className="py-2 text-light-emphasis"
                  >
                    <LogOut size={16} className="me-2" />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
            </Dropdown>
            <Link
              as={Link}
              to="/cart"
              className="position-relative me-3 mt-1 text-dark-emphasis"
            >
              <ShoppingCart size={20} />
              <Badge
                pill
                bg="danger"
                className="position-absolute start-100 translate-middle"
              >
                {cartCount}
              </Badge>
            </Link>
          </div>
        </Container>
      </Navbar>
      <div className="content">
        <Outlet />
      </div>
      <footer className="text-center mt-auto bg-white py-4">
        <Container>
          <h6>QUICK LINKS</h6>
          <Nav className="justify-content-center align-items-center fw-light">
            <Nav.Item>
              <Nav.Link href="/privacy-policy">Privacy Policy</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/terms-and-conditions">
                Terms & Conditions
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/refund-returns">Refund & Return Policy</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/shipping-policy">Shipping Policy</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/contact-us">Contact Us</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/about-us">About Us</Nav.Link>
            </Nav.Item>
          </Nav>
          <hr />
          <div>
            &copy; {new Date().getFullYear()} Sheenlac Paints Ltd. All rights
            reserved.
          </div>
        </Container>
      </footer>
    </Fragment>
  );
};

export default PublicLayout;
